// extracted by mini-css-extract-plugin
export default {"error":"DIF7ivRI_skr2vU0WtxQ","errorMessage":"cGHwAvIAjcL7qwRvvTga"};